import React from 'react'

import { LineChart, Line, XAxis, YAxis, CartesianGrid, ResponsiveContainer, Label } from 'recharts';

import { IChartProps } from '../../../interfaces/charts';

const LineChartComponent = (props: IChartProps) => {
    const { xLabel, yLabel, data, width, height, xInterval } = props;

    return (
        <div className='immersion_admin__chart_container'>
            <div className='immersion_admin__chart_container__label__X'>
                <h5 className='immersion_admin__chart_container__label__X__text'>{xLabel}</h5>
            </div>
            {/* <Div className='immersion_admin__chart_container__label__Y'>
                <H5 className='immersion_admin__chart_container__label__Y__text'>{yLabel}</H5>
            </Div> */}
            <ResponsiveContainer width={width} height={height}>
                <LineChart
                    data={data}
                    margin={{ top: 0, right: 0, left: 20, bottom: 0 }}
                >
                    <CartesianGrid
                        vertical={false}
                        stroke='#D8D8D8'
                        strokeWidth={2}
                    />

                    <XAxis
                        dataKey="name"
                        axisLine={false}
                        tickLine={false}
                        interval={xInterval ?? 2}
                    />
                    <YAxis
                        axisLine={false}
                        tickLine={false}
                        tickFormatter={(value) => value >= 1000 ? `${value / 1000}k` : value}
                    >
                        <Label
                            value={yLabel}
                            position="insideBottomLeft"
                            angle={-90}
                            style={{ fill: '#000000', fontSize: '16px', fontWeight: '600' }}
                        />
                    </YAxis>
                    <Line type="monotone" dataKey="value" stroke="#8884d8" dot={false} />
                </LineChart>
            </ResponsiveContainer>
        </div>
    )
}

export default LineChartComponent